import { IDLE_TIME_MIN } from './constants';

const contents = {
  'autoLogout.modal.title': 'Your session has timed out',
  'autoLogout.modal.description': `There has been no activity for the last ${IDLE_TIME_MIN} minutes. For your security, you will be logged out shortly. Please click continue to remain active.`,
};
export default contents;
